import React, { ReactElement, useEffect } from 'react'
import Divider from '../../Divider'
import TokenomicsOverview from './TokenomicsOverview'
import { ArtData } from '@/database/art'

const TokenomicsPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        window.location.hash = `#nft-${artData?.tokenId + tabName}#tokenomics`
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <TokenomicsOverview artData={artData} />
        </div>
    )
}

export default TokenomicsPanel
